import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaText } from '@inter-ikea-guida/skapa';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
import { AdditionalContentContainer } from './AdditionalContentContainer';
const StyledContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding-bottom: ${props => (props.$withBottomSpacing ? '2rem' : '0')};
`;
const StyledHeading = styled(SkapaText) `
  margin: 0;
`;
export const Guide = ({ children, sidebarHeading, subheading, additionalContent, withBottomSpacing }) => {
    const { isSidebarMode } = useGuidaUIStates();
    return (_jsxs(StyledContainer, { "data-testid": 'guide', "$withBottomSpacing": withBottomSpacing, children: [sidebarHeading && isSidebarMode && (_jsx(StyledHeading, { tagName: 'h1', textStyle: 'Heading.M', children: sidebarHeading })), subheading && _jsx(SkapaText, { textStyle: 'Heading.XS', children: subheading }), children, additionalContent && (_jsx(AdditionalContentContainer, { children: additionalContent }))] }));
};
//# sourceMappingURL=Guide.js.map